import { MY_SPACE_URL } from '@/modules/my-space/my-space.constants';
import { resolveCurrentUser } from '@/modules/user/user.service';

export default [
  {
    ...MY_SPACE_URL.search,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceSearch.vue'),
  },
  {
    ...MY_SPACE_URL.articles,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceArticles.vue'),
  },
  {
    ...MY_SPACE_URL.tracks,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceTracks.vue'),
  },
  {
    ...MY_SPACE_URL.questions,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceQuestions.vue'),
  },
  {
    ...MY_SPACE_URL.departments,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceDepartments.vue'),
  },
  {
    ...MY_SPACE_URL.tags,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceTags.vue'),
  },
  {
    ...MY_SPACE_URL.users,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceUsers.vue'),
  },
  {
    ...MY_SPACE_URL.ranking,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/my-space/views/MySpaceRanking.vue'),
  },
];

export function goToListDepartments($router) {
  $router.push({
    name: MY_SPACE_URL.departments.name,
  });
}

export function goToSearch($router, inputSearch) {
  $router.push({
    name: MY_SPACE_URL.search.name,
    query: { term: inputSearch },
  });
}
